<template>
    <div
        :class="{
            'c-form-control': true,
            'has-error': error,
            'has-short': short,
            'has-focus': focus,
            'has-icon': icon || iconType || iconClick,
            'has-content': value.length > 0
        }">
        <label :for="unique" class="c-form-control__field">
            <span class="c-form-control__placeholder">{{placeholder}}</span>
            <input
                :type="type || 'text'"
                :name="unique"
                :id="unique"
                @focus="focus = true"
                @blur="focus = false"
                v-bind:value="value"
                v-on:input="$emit('input', $event.target.value)"
                :disabled="disabled"
                :autofocus="autofocus"
                :required="required"
                class="c-form-control__control"
                :readonly="readonly || type === 'password'"
                onfocus="type === 'password' && this.removeAttribute('readonly')"
            />
            <span @click="clickIcon" v-if="icon && iconType !== 'password'" v-show="value.length > 0" class="c-form-control__icon">
                <svg-icon :icon="icon" />
            </span>
            <button type="button" @click="clickIcon" v-if="iconType === 'password'" v-show="value.length > 0" class="c-form-control__icon">
                <svg-icon v-show="type === 'password'" :icon="showIcon" />
                <svg-icon v-show="type === 'text'" :icon="hideIcon" />
            </button>
        </label>
        <span class="c-form-control__common" v-if="!error && short">{{short}}</span>
        <span class="c-form-control__common" v-if="error">{{error}}</span>
    </div>
</template>
<script>
import * as uuid4 from "uuid/v4";
import SvgIcon from "../ui/SvgIcon";

import mashShow from "@/assets/img/icons/mash-show.svg";
import mashHide from "@/assets/img/icons/mash-hide.svg";

export default {
  data() {
    return {
      focus: false,
      unique: "",
      showIcon: mashShow,
      hideIcon: mashHide
    };
  },
  props: {
    value: String,
    error: String,
    short: String,
    type: String,
    placeholder: String,
    autofocus: Boolean,
    disabled: Boolean,
    required: Boolean,
    readonly: Boolean,
    iconType: String,
    icon: String,
    iconClick: Function
  },
  components: {
    SvgIcon
  },
  mounted() {
    this.unique = uuid4();
  },
  methods: {
    clickIcon() {
      this.iconClick({ click: true });
    }
  }
};
</script>
